import React from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import ClevertapReact from "clevertap-react";

class CourseBox extends React.Component {
    constructor(props) {
        super(props);
        this.subject = this.props.subject;

        this.gotoPracticeQuestion = this.gotoPracticeQuestion.bind(this);
        this.gotoPracticeFlashcard = this.gotoPracticeFlashcard.bind(this);
        this.gotoPracticeCourse = this.gotoPracticeCourse.bind(this);
    }

    componentDidMount() {
    }

    gotoPracticeQuestion(evt) {
        ClevertapReact.event("Started Practice Question from " + this.subject.id, { 'userName': this.props.auth.user.userName });
        browserHistory.push({
            pathname: '/student/selfstudy/view/' + encodeURIComponent(this.subject.id) + '[[question]]',
            state: { subjectID: this.subject.id }
        });
    }

    gotoPracticeFlashcard(evt) {
        ClevertapReact.event("Started Practice Flashcards from " + this.subject.id, { 'userName': this.props.auth.user.userName });
        browserHistory.push({
            pathname: '/student/selfstudy/flashcard/' + encodeURIComponent(this.subject.id) + '[[flashcard]]',
            state: { subjectID: this.subject.id }
        });
    }

    gotoPracticeCourse(evt) {
        ClevertapReact.event("Started Practice Course from " + this.subject.id, { 'userName': this.props.auth.user.userName });
        browserHistory.push({
            pathname: '/student/selfstudy/course/' + encodeURIComponent(this.subject.id),
            state: { subjectID: this.subject.id }
        });
    }

    getSubjectClass(name) {
        if (name.toLowerCase().indexOf('geometry') > -1) {
            return 'typeIconsgeometry';
        }
        else if (name.toLowerCase().indexOf('algebra') > -1) {
            return 'typeIconsalgebra';
        } else if (name.toLowerCase().indexOf('earth science') > -1) {
            return 'typeIconsscience';
        } else if (name.toLowerCase().indexOf('global history') > -1) {
            return 'typeIconshistory';
        } else if (name.toLowerCase().indexOf('u.s. history') > -1) {
            return 'typeIconsUSHistory';
        } else if (name.toLowerCase().indexOf('environment') > -1) {
            return 'typeIconsenvironment';
        } else {
            return 'typeIconsscience';
        }
    }

    render() {
        let context = this;
        return (

            <div id="SelfStudy" className="col-lg-4 col-md-4 col-sm-6 col-xs-12 ">
                <div className="pacbox">
                    <div className="limitFilters">
                        <span className={this.getSubjectClass(context.subject.name)} />
                        <span className="contentType float-lft">
                            <span className="headsp " style={{ whiteSpace: 'normal' }}>{context.subject.name}</span>
                        </span>
                    </div>
                    <div id={context.subject.id + '-child'} style={{ textAlign: 'left', display: 'block' }}>
                        <div className="fieldBox">
                            <div className="col-lg-7 col-md-6 col-sm-6 col-xs-6  paddnone ">
                                <label htmlFor="subject2" className="pay_label css-label1 ">
                                    <a href="javascript:void 0">Practice Questions</a>
                                </label>
                            </div>
                            <div
                                className="col-lg-5 col-md-6 col-sm-6 col-xs-6 text-alignlft paddnone">
                                <div className="maincolblus marginrgt" onClick={context.gotoPracticeQuestion}>Go</div>
                            </div>
                        </div>
                        <div style={{ clear: 'both' }} />
                        <div className="fieldBox">
                            <div className="col-lg-7 col-md-7 col-sm-6 col-xs-6  paddnone">
                                <label htmlFor="subject2" className="pay_label css-label1">
                                    <a href="javascript:void 0">Practice Flash Cards</a>
                                </label>
                            </div>
                            <div
                                className="col-lg-5 col-md-5 col-sm-6 col-xs-6 text-alignlft paddnone">
                                <div className="maincolblus marginrgt" onClick={context.gotoPracticeFlashcard}>Go</div>
                            </div>
                        </div>
                        <div style={{ clear: 'both' }} />
                        {/*<div className="fieldBox">
                        <div className="col-lg-7 col-md-6 col-sm-6 col-xs-6  paddnone">
                            <label htmlFor="subject2" className="pay_label css-label1">
                                <a href="javascript:void 0">Practice Course</a>
                                <br/>
                            </label>
                        </div>
                        <div
                            className="col-lg-5 col-md-6 col-sm-6 col-xs-6 text-alignlft paddnone">
                            <div className="maincolblus marginrgt" onClick={context.gotoPracticeCourse}>Start</div>
                        </div>
                    </div>*/}
                    </div>
                    <div style={{ clear: 'both' }} />
                </div>
            </div>

        );
    }
}

function mapStateToProps(state) {
    return {
        ...state
    }
}

export default connect(mapStateToProps)(CourseBox);
